/**
 * @license lucide-vue-next v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const RotateCcwKey = createLucideIcon("rotate-ccw-key", [
  ["path", { d: "M12 7v6", key: "lw1j43" }],
  ["path", { d: "M12 9h2", key: "1lpap9" }],
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.74 9.74 0 0 0-6.74 2.74L3 8", key: "g2jlw" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
  ["circle", { cx: "12", cy: "15", r: "2", key: "1vpstw" }]
]);

export { RotateCcwKey as default };
//# sourceMappingURL=rotate-ccw-key.js.map
